import {Base} from "@/api/Base"

export class EmployeeEntryRecordList extends Base {
    path = "employeeEntryRecord/list"
}